import React, { useState, useEffect } from 'react';
import { Box, Badge, Button, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Paper, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Pagination, Stack, FormControl, InputLabel, Select, MenuItem, FormControlLabel, RadioGroup, Radio, Chip, Tooltip, Avatar } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import ClearIcon from '@mui/icons-material/Clear';
import Paginationnew from '../../Uitiles/Paginationnew';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';

const Postes = () => {
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editingPost, setEditingPost] = useState(null);
  const [viewingPost, setViewingPost] = useState(null);

  // Form states
  const [postTitle, setPostTitle] = useState('');
  const [postDescription, setPostDescription] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [postType, setPostType] = useState('free');
  const [postCost, setPostCost] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileId, setFileId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [Specialization, setSpecialization] = useState([]);
  const [Services, setServices] = useState([]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tragettype, setTragettype] = useState('none');
  const [targetdata, setTargetdata] = useState([]);
  const [targetid, setTargetid] = useState(null);
  const [targetloading, setTargetloading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  // Categories and subcategories data
  const categories = [
    { id: 1, name: 'Health & Wellness', subcategories: ['Mental Health', 'Physical Health', 'Nutrition', 'Fitness'] },
    { id: 2, name: 'Medical', subcategories: ['Cardiology', 'Dermatology', 'Pediatrics', 'Surgery'] },
    { id: 3, name: 'Lifestyle', subcategories: ['Diet', 'Exercise', 'Sleep', 'Stress Management'] },
    { id: 4, name: 'Technology', subcategories: ['Health Apps', 'Medical Devices', 'Telemedicine', 'AI in Healthcare'] }
  ];

  useEffect(() => {
    getSpecialization();
    getServices();
    getPosts();
  }, []);

  // Add search effect
  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      getPosts();
    }, 500); // Debounce search by 500ms

    return () => clearTimeout(delayedSearch);
  }, [searchQuery]);





  const getPosts = async () => {
    try {
      setLoading(true);
      const tableSchema = '';
      const tableName = 'posts'; // Assuming your posts table name
      const conditions = {};
      const orderBy = 'id DESC';
      const search = {
        ...(searchQuery && {
          title: searchQuery,
          description: searchQuery,
          // Add other searchable fields as needed
        })
      };
      const pagination = {
        page: page,
        limit: rowsPerPage
      };
      const margedata = [
        {
          target_table: "specialities",
          target_column: "id",
          target_value: "speciality_id",
          target_label: "specialities"
        },
        {
          target_table: "services",
          target_column: "id",
          target_value: "service_id",
          target_label: "services"
        }
      ];
      const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log('getPosts response :', response);
      if (response.data && response.data.length > 0) {
        setPosts(response.data);
      } else {
        setPosts([]);
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const getServices = async () => {
    try {
      const tableSchema = '';
      const tableName = 'services';
      const conditions = {
        ...(selectedCategory && { speciality_id: selectedCategory })
      };
      const orderBy = 'id DESC';
      const search = {};
      const pagination = {};
      const margedata = [];
      const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log('getServices response', response);
      if (response.data.length > 0) {
        setServices(response.data);
      } else {
        setServices([]);
      }
    } catch (error) {
      console.error('Error fetching services:', error);
      setServices([]);
    }
  };

  const getSpecialization = async () => {
    try {
      const tableSchema = '';
      const tableName = 'specialities';
      const conditions = {};
      const orderBy = 'id DESC';
      const search = {};
      const pagination = {};
      const margedata = [];
      const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log('getSpecialization response', response);
      if (response.data && response.data.length > 0) {
        setSpecialization(response.data);
      } else {
        setSpecialization([]);
      }
    } catch (error) {
      console.error('Error fetching specialization:', error);
      setSpecialization([]);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    resetForm();
  };

  const handleClose = () => {
    setOpen(false);
    setEditOpen(false);
    setViewOpen(false);
    resetForm();
  };

  const resetForm = () => {
    setPostTitle('');
    setPostDescription('');
    setSelectedCategory('');
    setSelectedSubCategory('');
    setPostType('free');
    setPostCost('');
    setSelectedFile(null);
    setPreviewImage(null);
    setEditingPost(null);
    setViewingPost(null);
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      const upload = await OneKlicksFileSDK.uploadFile('posts', 'public', file);
      setPreviewImage(upload.file.root + '/' + upload.file.fileName);
      setFileId(upload.file.id);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const postData = {
        title: postTitle,
        description: postDescription,
        speciality_id: selectedCategory,
        service_id: selectedSubCategory,
        type: postType,
        cost: postType === 'paid' ? parseFloat(postCost) : 0,
        image: fileId,
        image_url: previewImage,
        status: 'active'
      };

      const tableSchema = '';
      const tableName = 'posts';

      if (editingPost) {
        // Update existing post
        const conditions = { id: editingPost.id };
        const response = await oneKlicks.update(tableSchema, tableName, postData, conditions);
        if (!response.success) {
          throw new Error(response.message);
        }
        console.log('Post updated:', response);
      } else {
        // Add new post
        const response = await oneKlicks.create(tableSchema, tableName, postData, {});
        if (!response.success) {
          throw new Error(response.message);
        }
        console.log('Post created:', response);
      }

      // Refresh posts list
      await getPosts();
      handleClose();
    } catch (error) {
      console.error('Error saving post:', error);
    } finally {
      setLoading(false);
    }
  };

  const openView = (post) => {
    setViewingPost(post);
    setViewOpen(true);
  };

  const openEdit = (post) => {
    setEditingPost(post);
    setPostTitle(post.title);
    setPostDescription(post.description);
    setSelectedCategory(post.speciality_id || '');
    setSelectedSubCategory(post.service_id || '');
    setPostType(post.type);
    setPostCost(post.cost ? post.cost.toString() : '');
    setPreviewImage(post.image_url);
    setEditOpen(true);
  };

  const handleDelete = async (post) => {
    if (window.confirm(`Are you sure you want to delete "${post.title}"?`)) {
      try {
        setLoading(true);
        const tableSchema = '';
        const tableName = 'posts';
        const conditions = { id: post.id };
        const response = await oneKlicks.delete(tableSchema, tableName, conditions);
        console.log('Post deleted:', response);

        // Refresh posts list
        await getPosts();
      } catch (error) {
        console.error('Error deleting post:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Status Badge Component
  const StatusBadge = ({ status }) => {
    const getStatusColor = (status) => {
      switch (status) {
        case 'active': return 'success';
        case 'inactive': return 'warning';
        case 'draft': return 'info';
        default: return 'default';
      }
    };

    return (
      <Chip
        label={status}
        color={getStatusColor(status)}
        size="small"
        variant="outlined"
      />
    );
  };





  // Since we're using database pagination, we don't need client-side filtering
  const totalPages = Math.ceil(posts.length / rowsPerPage) || 1;
  const paginatedPosts = posts; // Data is already paginated from the API

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Refresh posts when page changes
  useEffect(() => {
    getPosts();
  }, [page]);

  const clearSearch = () => {
    setSearchQuery('');
    setPage(1);
  };

  const getTargetid = async () => {
    setTargetloading(true);
    try {
      const tableSchema = '';
      const tableName = 'users';
      const conditions = { user_type: tragettype };
      const orderBy = 'id DESC';
      const search = {};
      const pagination = {};
      const margedata = [];
      const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log('getTargetid response', response);
      if (response.data && response.data.length > 0) {
        setTargetdata(response.data);
      } else {
        setTargetid([]);
      }
    }
    catch (error) {
      console.error('Error fetching targetid:', error);
      setTargetdata([]);
    } finally {
      setTargetloading(false);
    }
  };

  return (
    <div className="posts-container">
      <div className="dc-haslayout dc-dbsectionspace">
        <div className="container-fluid py-3">
          <div className="card mb-5">
            <div className="card-body">
              <div className="align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2  mb-2">
                  <h5 className="mb-0 font-weight-bold mr-3">Posts Management</h5>
                  <Badge bg="info">Posts</Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>

                  <TextField
                    variant="outlined"
                    placeholder="Search posts by title or description..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setPage(1);
                    }}
                    InputProps={{
                      startAdornment: <SearchIcon />,
                      endAdornment: searchQuery && (
                        <IconButton
                          size="small"
                          onClick={clearSearch}
                          sx={{ mr: -1 }}
                        >
                          <ClearIcon />
                        </IconButton>
                      ),
                    }}
                    size="small"
                    sx={{ width: '350px', background: '#fff', borderRadius: 1 }}
                  />
                  <Button variant="contained" color="primary" onClick={handleClickOpen} startIcon={<AddIcon />} sx={{ height: 50, minWidth: 180, fontWeight: 600 }}>
                    Add New Post
                  </Button>

                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <Table hover size="sm" className="mb-0 align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: 70 }}>ID</th>
                      <th>Title</th>
                      <th>Speciality</th>
                      <th>Service</th>
                      <th>Type</th>
                      <th>Cost</th>
                      <th>Image</th>
                      <th style={{ width: 120 }}>Status</th>
                      <th style={{ width: 180 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && (
                      <tr>
                        <td colSpan={9} className="text-center text-muted py-4">
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            Loading posts...
                          </div>
                        </td>
                      </tr>
                    )}
                    {!loading && paginatedPosts.length === 0 && (
                      <tr>
                        <td colSpan={9} className="text-center text-muted py-4">No posts found.</td>
                      </tr>
                    )}
                    {!loading && paginatedPosts.map((post) => (
                      <tr key={post.id}>
                        <td>#{post.id}</td>
                        <td>
                          <div>
                            <div className="fw-bold">{post.title}</div>
                            <small className="text-muted">{post.description}</small>
                          </div>
                        </td>
                        <td style={{ maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{post.specialities[0].name}</td>
                        <td style={{ maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{post.services[0].name}</td>
                        <td>
                          <Chip
                            icon={post.type === 'free' ? <FreeBreakfastIcon /> : <AttachMoneyIcon />}
                            label={post.type}
                            color={post.type === 'free' ? 'success' : 'primary'}
                            size="small"
                            variant="outlined"
                          />
                        </td>
                        <td>
                          {post.type === 'paid' ? `$${post.cost}` : 'Free'}
                        </td>
                        <td>
                          <ImageShow
                            url={post.image_url}
                            width={40}
                            height={40}
                            alt={post.title}
                            style={{ width: 40, height: 40 }}
                          />
                        </td>
                        <td><StatusBadge status={post.status} /></td>
                        <td>
                          <div className="d-flex" style={{ gap: 8 }}>
                            <Tooltip title="View Post">
                              <IconButton size="small" color="info" onClick={() => openView(post)}>
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit Post">
                              <IconButton size="small" color="primary" onClick={() => openEdit(post)}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Post">
                              <IconButton size="small" color="error" onClick={() => handleDelete(post)}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
            </div>
          </div>
        </div>

        {/* Add/Edit Post Dialog */}
        <Dialog open={open || editOpen} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editingPost ? 'Edit Post' : 'Add New Post'}
          </DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 1 }}>
              <TextField
                autoFocus
                margin="dense"
                label="Post Title"
                type="text"
                fullWidth
                value={postTitle}
                onChange={(e) => setPostTitle(e.target.value)}
                sx={{ mb: 2 }}
              />

              <TextField
                margin="dense"
                label="Post Description"
                multiline
                rows={3}
                fullWidth
                value={postDescription}
                onChange={(e) => setPostDescription(e.target.value)}
                sx={{ mb: 2 }}
              />

              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Specialization</InputLabel>
                  <Select
                    value={selectedCategory}
                    label="Specialization"
                    search={true}
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                      getServices();
                      setSelectedSubCategory(''); // Reset subcategory when category changes
                    }}
                  >
                    <MenuItem value="">
                      <em>All Specializations</em>
                    </MenuItem>
                    {Specialization.map((category) => (
                      <MenuItem key={category.id} value={category.id} search={true} style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel>Service</InputLabel>
                  <Select
                    value={selectedSubCategory}
                    label="Service"
                    search={true}
                    onChange={(e) => setSelectedSubCategory(e.target.value)}
                    disabled={!selectedCategory}
                  >
                    {Services.map((sub) => (
                      <MenuItem key={sub.id} value={sub.id} search={true} style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}>
                        {sub.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Post Type
                </Typography>
                <RadioGroup
                  row
                  value={postType}
                  onChange={(e) => setPostType(e.target.value)}
                >
                  <FormControlLabel
                    value="free"
                    control={<Radio />}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FreeBreakfastIcon color="success" />
                        Free
                      </Box>
                    }
                  />
                  <FormControlLabel
                    value="paid"
                    control={<Radio />}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AttachMoneyIcon color="primary" />
                        Paid
                      </Box>
                    }
                  />
                </RadioGroup>
              </Box>


              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>

                <FormControl fullWidth>
                  <InputLabel>Target Type</InputLabel>
                  <Select
                    value={tragettype}
                    label="Target Type"
                    search={true}
                    onChange={(e) => {
                      setTragettype(e.target.value);
                      getTargetid();
                      setTargetid(''); // Reset subcategory when category changes
                    }}
                  >
                    <MenuItem value="none">All Target Types</MenuItem>
                    <MenuItem value="doctor">Doctor</MenuItem>
                    <MenuItem value="hospital">Hospital</MenuItem>
                    <MenuItem value="user">User</MenuItem>
                    <MenuItem value="lab">Lab</MenuItem>
                    <MenuItem value="pharmacy">Pharmacy</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                </FormControl>


                {tragettype !== 'none' && (
                  <FormControl fullWidth>
                    <InputLabel>Target ID</InputLabel>
                    <Select
                      value={targetid}
                      label="Target ID"
                      search={true}
                    >
                      {targetloading ? (
                        <MenuItem value="">
                          <em>Loading...</em>
                        </MenuItem>
                      ) : (
                        targetdata.map((target) => (
                          <MenuItem key={target.id} value={target.id} search={true} style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '300px' }}>
                            <ImageShow url={target.profile_photo_url} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%', marginRight: 10 }} /> 
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                              <span style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginLeft: 10 }}>{target.display_name}</span>
                              <span style={{ fontSize: 12, color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginLeft: 10 }}>{tragettype === 'doctor' ? 'Doctor' : tragettype === 'hospital' ? 'Hospital' : tragettype === 'lab' ? 'Lab' : tragettype === 'pharmacy' ? 'Pharmacy' : 'Other'} {target.id}</span>
                            </div>
                            
                          </MenuItem>
                        ))
                      )}
                      
                    </Select>
                  </FormControl>
                )}

              </Box>

              {postType === 'paid' && (
                <TextField
                  margin="dense"
                  label="Cost ($)"
                  type="number"
                  fullWidth
                  value={postCost}
                  onChange={(e) => setPostCost(e.target.value)}
                  sx={{ mb: 2 }}
                  inputProps={{ min: 0, step: 0.01 }}
                />
              )}

              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Post Image
                </Typography>
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="post-image-upload"
                  type="file"
                  onChange={handleFileChange}
                />
                <label htmlFor="post-image-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                    sx={{ mb: 2 }}
                  >
                    Upload Image
                  </Button>
                </label>

                {previewImage && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" gutterBottom>
                      Preview:
                    </Typography>
                    <ImageShow
                      url={previewImage}
                      width={150}
                      height={100}
                      alt={previewImage}
                      style={{ width: '100%', height: '100%' }}
                      type="posts"
                    />
                  </Box>
                )}

                {selectedFile && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Selected file: {selectedFile.name}
                  </Typography>
                )}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              {editingPost ? 'Update Post' : 'Add Post'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* View Post Dialog */}
        <Dialog open={viewOpen} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>Post Details</DialogTitle>
          <DialogContent>
            {viewingPost && (
              <Box>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                  <ImageShow
                    url={viewingPost.image_url}
                    width={100}
                    height={80}
                    alt={viewingPost.title}
                    style={{ width: 100, height: 80 }}
                    type="posts"
                  />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      {viewingPost.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {viewingPost.description}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      <Chip label={viewingPost.specialities[0].name} size="small" />
                      <Chip label={viewingPost.services[0].name} size="small" variant="outlined" />
                      <Chip
                        icon={viewingPost.type === 'free' ? <FreeBreakfastIcon /> : <AttachMoneyIcon />}
                        label={viewingPost.type === 'free' ? 'Free' : `$${viewingPost.cost}`}
                        color={viewingPost.type === 'free' ? 'success' : 'primary'}
                        size="small"
                      />
                      <StatusBadge status={viewingPost.status} />
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Created At
                    </Typography>
                    <Typography variant="body2">
                      {viewingPost.created_at ? new Date(viewingPost.created_at).toLocaleString() : 'N/A'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Post ID
                    </Typography>
                    <Typography variant="body2">
                      #{viewingPost.id}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default Postes; 
